import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Observable } from 'rxjs';
import { SbConfirmDialogData } from './sb-confirm-dialog-data';
import { SbConfirmDialogComponent } from './sb-confirm-dialog.component';

/** @deprecated - This component relies on the material components that we want to remove. Please use SbConfirmDialogComponent instead */
@Injectable({
    providedIn: 'root'
})
export class SbConfirmDialogService {
    constructor(public dialog: MatDialog) {}

    /**
     * Opens modal confirmation dialog.
     * Returned Observable closes after first.
     * @returns Observable true if confirmed, observable false if cancel
     */
    public confirmDialog(data: SbConfirmDialogData): Observable<boolean> {
        return this.dialog
            .open(SbConfirmDialogComponent, {
                data,
                width: '500px'
            })
            .afterClosed();
    }
}
